import { useEffect, useRef, useState } from 'react'
import Stars from './Stars'
import { LazyAxios, catchError, ErrorUp, FieldError, getFieldErrorMessage, getPathName, getToken, InfoPopUp, NoData, setDefaultAll, Sloading, StartLoading, SuccessUp } from '../../base'
import { useDispatch, useSelector } from 'react-redux'
import errorName, { base_loading_time, intersection_threshold, url } from '../../base/Variables'
import { Carousel } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'

function ReviewData({ id, page, setPerror, setParentData, total_review, avg_rating }) {
    const [totalReview, setTotalReview] = useState(0)
    const [avgRating, setAvgRating] = useState(0)
    const [otherReview, setOtherReview] = useState(null)
    const [myReview, setMyReview] = useState(null)


    const [loading, setLoading] = useState(true)
    const [adding, setAdding] = useState(false)
    const [data, setData] = useState({ 'rating': 5, 'review': '' })
    const [words, setWords] = useState(0)
    const [error, setError] = useState(null)
    const [popUpMessage, setPopUpMessage] = useState(null)
    const [fieldError, setFieldError] = useState(null)
    const [success, setSucces] = useState(null)

    const user = useSelector((state) => state.appSlice.user)
    const componentRef = useRef(null)
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const newUrl = page === 'app' ? `${url}/api/v1/app/reviews/` : `${url}/api/v1/${page}/${id}/reviews/`

    function changeData(e) {
        setData((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
    }

    async function getTopReviews() {
        setLoading(true)
        try {
            const axios = await LazyAxios()
            const request = await axios.get(newUrl)
            console.log(request.data)
            if (request.data && request.data[page] === null) {
                setParentData(null)
            }
            else if (request.data && request.data.other_review) {
                setOtherReview(request.data.other_review)
            }
            setLoading(false)
        }
        catch (error) {
            setLoading(false)
            page !== 'app' && setPerror(catchError(error).error_message)
        }
    }

    async function getMyReview() {
        try {
            const token = getToken()
            const axios = await LazyAxios()
            const request = await axios.get(page === 'app' ? `${url}/api/v1/${page}/myreview/` : `${url}/api/v1/${page}/${id}/myreview/`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            console.log(request.data)
            if (request.data && request.data[page] === null) {
                setParentData(null)
            }
            else if (request.data && request.data.my_review) {
                setMyReview(request.data.my_review)
            }
        }
        catch (error) {
            if (page !== 'app') {
                const er = catchError(error).error_message
                if (er !== errorName.authenticationError && er !== errorName.userNotFound) {
                    setPerror(catchError(error).error_message)
                }
                else {
                    setDefaultAll(dispatch, true)
                }
            }
        }
    }

    async function addReview() {
        const trimed_review = data.review.trim()
        if (data.rating < 1 || data.rating > 5) {
            setFieldError(getFieldErrorMessage('Please give rating between 1 to 5 !', 'review'))
        }
        else if (trimed_review.length < 5) {
            setFieldError(getFieldErrorMessage('Please write a review !', 'review'))
        }
        else if (trimed_review.length > 500) {
            setFieldError(getFieldErrorMessage('Maximum 500 words are allowed !', 'review'))
        }
        else {
            setAdding(true)
            try {
                const token = getToken()
                const axios = await LazyAxios()
                const request = await axios.post(newUrl, data, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                console.log(request.data)
                if (request.data && request.data.user === null) {
                    setDefaultAll(dispatch, true)
                    setPopUpMessage('Oops! Session expires, please login again.')
                }
                else if (request.data && request.data[page] === null) {
                    setParentData(null)
                }
                else if (request.data && request.data.error_message === 'Oops! You already reviewd.') {
                    setMyReview([])
                    setPopUpMessage(request.data.error_message)
                }
                else if (request.data && request.data.error_message) {
                    setPopUpMessage(request.data.error_message)
                }
                else {
                    setMyReview(request.data.data)
                }
            }
            catch (error) {
                if (page !== 'app') {
                    const er = catchError(error).error_message
                    if (er !== errorName.authenticationError && er !== errorName.userNotFound && er !== errorName.notNormalUser) {
                        setPerror(catchError(error).error_message)
                    }
                    else {
                        setDefaultAll(dispatch, true)
                        setPopUpMessage('Please login to write a review !')
                    }
                }
                else {
                    const er = catchError(error).error_message
                    if (er === errorName.authenticationError && er === errorName.userNotFound && er === errorName.notNormalUser) {
                        setDefaultAll(dispatch, true)
                    }
                    setPopUpMessage(er)
                }
            }
            finally {
                const timeout = setTimeout(() => {
                    setAdding(false)
                }, [base_loading_time])

                return () => clearTimeout(timeout)
            }
        }
    }

    useEffect(() => {
        if (id) {
            setTotalReview(total_review)
            setAvgRating(avg_rating.toFixed(1))
        }

        const observer = new IntersectionObserver(
            (entries) => {
                // Check if the child component is in the viewport
                if (entries[0].isIntersecting && loading) {
                    // Trigger the API call or any function passed as prop
                    if (id) {
                        getTopReviews()
                        getMyReview()
                    }
                    else {
                        setLoading(false)
                    }
                }
            },
            {
                root: null, // default to the viewport
                threshold: intersection_threshold, // 10% of the component must be visible
            }
        );

        if (componentRef.current) {
            observer.observe(componentRef.current);
        }

        return () => {
            if (componentRef.current) {
                observer.unobserve(componentRef.current);
            }
        };
    }, [id, loading])

    useEffect(() => {
        data && setWords(data.review.trim().length)
    }, [data])

    console.log(avgRating, totalReview)
    return (
        <div className='reviewData' id='reviewData' ref={componentRef} style={loading ? { minHeight: '1200px', overflow: 'hidden', scrollbarWidth: 'none' } : { overflow: 'hidden', scrollbarWidth: 'none' }}>
            <div className='text-center'>Total Reviews : {totalReview}</div>
            <div className='d-flex justify-content-center gap-2'>Rating : <Stars rating={avgRating} show={false} /></div>
            <div className='divider w-25 m-auto'>*</div>

            <div className='row mt-lg-5 mb-3' style={{ alignItems: 'center' }}>
                <div className='col-lg-6 mt-3 mt-md-0' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {otherReview ?
                        <div className='reviews w-100'>
                            <div className='text-center h5 heading mb-0'>Customer Reviews</div>
                            <Carousel>
                                {otherReview !== null && otherReview.map((item, key) => {
                                    return (
                                        <Carousel.Item key={key}>
                                            <div className="singleReview" key={key}>
                                                <h1 className="h6" style={{ color: 'red' }}>{item.user_name}</h1>
                                                <h1 className="h5 d-flex"><Stars rating={item.rating} show={false} /></h1>
                                                <h1 className="truncate-8 text-center" style={{ fontSize: '14.3px' }}>{item.review}</h1>
                                            </div>
                                        </Carousel.Item>
                                    )
                                })}
                            </Carousel>

                        </div> : <NoData message={'Oops! No Review found, be the 1st to review'} height={'280px'} />
                    }
                </div>
                <div className='col-lg-6 justify-content-center d-flex align-items-center' style={{ minHeight: '280px' }}>
                    {user ?
                        myReview ?
                            myReview.length === 0 ?
                                <div className='text-center heading h5'>You already Reviewd </div> :
                                <div className='d-flex reviews mt-5 mt-lg-0' style={{ padding: '5px', width: '100%', minHeight: '230px', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div className='h5 heading mb-0'>Your Review</div>
                                    <Carousel>
                                        <Carousel.Item key={1}>
                                            <div className="singleReview" key={1}>
                                                <h1 className="h6" style={{ color: 'red' }}>{user}</h1>
                                                <h1 className="h5 d-flex"><Stars rating={myReview.rating} show={false} /></h1>
                                                <h1 className="truncate-8 text-center" style={{ fontSize: '14.3px' }}>{myReview.review}</h1>
                                            </div>
                                        </Carousel.Item>
                                    </Carousel>
                                </div> :
                            <div className='reviewInput mt-3 mt-md-0' style={{ maxWidth: '600px', margin: 'auto', flex: '1' }}>
                                <div className='text-center heading mt-0 mb-0 mb-md-2 h5'>Add Your Review</div>
                                <label className='h7'>Rating :</label>
                                <select className='h7' name='rating' value={data.rating} onChange={(e) => changeData(e)} style={{ width: 'fit-content', display: 'inline', marginLeft: '10px' }}>
                                    <option value={5}>5</option>
                                    <option value={4}>4</option>
                                    <option value={3}>3</option>
                                    <option value={2}>2</option>
                                    <option value={1}>1</option>
                                </select>
                                <FieldError error={fieldError} setError={setFieldError} field='rating' />
                                <br />
                                <label className='h7'>Write a Review : <span className='smallText' style={{ color: 'red' }}> (words : {words})</span> </label>
                                <textarea className='h7' rows={7} name='review' value={data.review} onChange={(e) => changeData(e)} />
                                <FieldError error={fieldError} setError={setFieldError} field='review' />
                                <button className='secondryButton mt-2 mt-md-3' style={{ width: '100px' }} onClick={() => addReview()} disabled={adding ? true : false}>{adding ? <Sloading width={'25.5px'} /> : 'Add'}</button>
                            </div> :
                        <div>
                            <div className='text-center mb-3 h6'>You can not Review</div>
                            <button className='secondryButton' style={{ margin: 'auto' }} onClick={() => navigate(`/user/loginUser/?redirect=${getPathName(location)}`)}>Login To Review</button>
                        </div>}

                </div>
            </div>

            {
                adding ? <StartLoading /> :
                    popUpMessage ? <InfoPopUp popUpMessage={popUpMessage} setPopUpMessage={setPopUpMessage} /> :
                        error ? <ErrorUp message={error} removeMessage={setError} /> : success ? <SuccessUp message={success} removeMessage={setSucces} /> : <></>}
        </div>
    )
}

export default ReviewData